import * as borogove from "borogove";

const hideSchemes =
	/^(?:tel:|xmpp:|bitcoin:|bitcoincash:|monero:|ethereum:|https:\/\/(?:www\.)?patreon\.com\/c\/|https:\/\/liberapay\.com\/)/;

const Item = ({ item }: { item: borogove.ProfileItem }) => {
	return (
		<>
			{item.key !== "email" &&
				item.text().map((value, idx) => (
					<span key={idx} className={`p-${item.key}`}>
						{value}
					</span>
				))}
			{item.key === "email" &&
				item
					.text()
					.filter((v) => v !== "")
					.map((value, idx) => (
						<a className={`u-${item.key}`} key={idx} href={`mailto:${value}`}>
							{value}
						</a>
					))}
			{item.uri().map((value, idx) => (
				<a className={`u-${item.key}`} key={idx} href={value}>
					{value.replace(hideSchemes, "")}
				</a>
			))}
			{item.date().map((value, idx) => (
				<time className={`dt-${item.key}`} key={idx} dateTime={value}>
					{value}
				</time>
			))}
		</>
	);
};

export const Profile = ({ profile }: { profile: borogove.Profile }) => {
	return (
		<div className="h-card profile">
			{profile.items
				.filter(
					(item) => !["uid", "prodid", "version", "rev"].includes(item.key),
				)
				.map((item) => (
					<Item key={item.id} item={item} />
				))}
		</div>
	);
};
